<template>
    <div v-if="isLoadingFinish">
        <div class="payByMethod" v-if="paymentType=='MOBILEALIPAY' || paymentType == 'UNIONPAY'" v-html="paymentContent.checkoutShape"></div>
        <div class="page-payment" v-show="isShowAlipayWarning">
            <div><img src="https://resource.rcclchina.com.cn/paySuccess/arrow.png" class="arrow"></div>
            <div class="aliPay_hint">
                <p>点击右上方</p>
                <p>选择用浏览器打开支付</p>
            </div>
        </div>
    </div>
</template>

<script>
import wechatHelper from '@/utilities/wechatHelper'
import api from '@/api'
export default {
    name: "PayByMethod",
    data() {
        return {
            paymentContent: {},
            paymentType: "",
            orderId: "",
            requestId: "",
            isShowAlipayWarning: false,
            isLoadingFinish: false
        }
    },
    async beforeMount () {
        await this.initPage();
    },
    beforeDestroy () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
    },
    mounted () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: true, isHideFooter: true})
        
    },
    methods: {
        async initPage() {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
              return this.$router.push({ name: 'Login', query:{
                  returnUrl: encodeURIComponent(location.href)
                }})
            }
            // 如果没有预订参数，返回上一页
            const query = this.$router.currentRoute.query;
            if (!query) {
                return this.$router.go(-1)
            }
            const bookingId = query.bookingId;
            const paymentType = query.paymentType;
            const payMethod = query.payMethod;
            if (!bookingId || bookingId.length == 0
            || !paymentType || paymentType.length == 0
            || !payMethod || payMethod.length == 0) {
                return location.href = decodeURIComponent(query.returnUrl)
            }

            const request = {
                // 使用加密字段encBookingId
                encBookingId:bookingId,
                paymentType,
                payMethod,
                wechatOpenId: this.$store.state.user.wechatOpenId
            }
            this.$loading.show()
            const { success, data, errMsg } = await api.booking.payByMethodHP(request)
            this.$loading.hide()
            if (!success) {
                console.error(errMsg);
                return location.href = decodeURIComponent(query.returnUrl)
            }
            if (data && data.checkoutShape && data.checkoutShape.length > 0) {
                this.paymentContent = data;
                this.paymentType = payMethod;
                this.isLoadingFinish = true;
                this.$nextTick(()=> {
                    this.processPayMethod()
                })
            } else {
                return location.href = decodeURIComponent(query.returnUrl)
            }
        },
        processPayMethod() {
            switch(this.paymentType) {
                case 'MOBILEWECHATPAY': {
                    this.h5wechatPayHandler()
                    break
                }
                case 'WECHATPAY': {
                    this.wechatPayHandler()
                    break
                }
                case 'MOBILEALIPAY': {
                    this.mobileAlipayFormHandler()
                    break
                }
                case 'UNIONPAY' : {
                    this.unionPayHandler()
                    break
                }
                default: break
            }
        },
        h5wechatPayHandler() {
            window.location.href = `${this.paymentContent.checkoutShape}&redirect_url=${this.paySuccessUrl}`
        },
        wechatPayHandler () {
            var openId = this.$store.state.user.wechatOpenId
            if (!openId || openId == '') {
                return wechatHelper.wechatAuth()
            }
            if (typeof window.WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                }
            } else {
                this.onBridgeReady()
            }
        },
        mobileAlipayFormHandler () {
            if (wechatHelper.isWeixinBrowser()) {
                this.isShowAlipayWarning = true
                return
            }
            const forms = document.getElementsByTagName('form')
            if (forms) {
                forms[0].submit()
            }
        },
        unionPayHandler () {
            const forms = document.getElementById('pay_form')
            if (forms) {
                forms.action = process.env.VUE_APP_UNION_PAY_URL
                forms.submit()
            }
        },
        onBridgeReady() {
            const wxParam = this.paymentContent.checkoutShape
            const wxrdata = JSON.parse(wxParam)
            const paySuccessUrl = this.paySuccessUrl
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                "appId": wxrdata.appId,     //公众号名称，由商户传入
                "timeStamp": wxrdata.timeStamp,         //时间戳，自1970年以来的秒数
                "nonceStr": wxrdata.nonceStr, //随机串
                "package": wxrdata.package,
                "signType": wxrdata.signType,         //微信签名方式：
                "paySign": wxrdata.paySign //微信签名
                },
                function (res) {
                    // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        setTimeout(function () {
                            window.location.href = paySuccessUrl
                        }, 2000)
                    }
                }
            );
        }
    },
    computed: {
        paySuccessUrl() {
            return `${process.env.VUE_APP_BASE_URL}${process.env.VUE_APP_PAY_SUCCESS_URL}?paymentId=${this.paymentContent.orderId}`
        }
    }
}
</script>

<style lang="less" scoped>
.payByMethod {
    display: none;
}

.page-payment {
    top: -10px;
}
</style>